import { useCallback, useState } from 'react';
export const INSTALLATION_BLOCKING_APIS = {
  SCOPES: 'SCOPES',
  INSTALLATION_CONFIG: 'INSTALLATION_CONFIG',
  LATEST_VERSION_DETAILS: 'LATEST_VERSION_DETAILS' /* For egress, analytics, DaRe etc*/
};
const {
  SCOPES,
  INSTALLATION_CONFIG,
  LATEST_VERSION_DETAILS
} = INSTALLATION_BLOCKING_APIS;
const defaultState = {
  error: false,
  loading: false
};
export const useErrorAndLoadingStates = () => {
  const [scopesErrorOrLoading, setScopesErrorOrLoading] = useState(defaultState);
  const [installConfigLoadingOrErr, setInstallConfigLoadingOrErr] = useState(defaultState);
  const [versionDetailsErrorOrLoading, setVersionDetailsErrorOrLoading] = useState(defaultState);
  const updateErrAndLoadingState = useCallback((apiType, value) => {
    switch (apiType) {
      case SCOPES:
        {
          setScopesErrorOrLoading(value);
          break;
        }
      case INSTALLATION_CONFIG:
        {
          setInstallConfigLoadingOrErr(value);
          break;
        }
      case LATEST_VERSION_DETAILS:
        {
          setVersionDetailsErrorOrLoading(value);
          break;
        }
      default:
        {
          break;
        }
    }
  }, [setScopesErrorOrLoading, setInstallConfigLoadingOrErr, setVersionDetailsErrorOrLoading]);
  const loading = scopesErrorOrLoading.loading || installConfigLoadingOrErr.loading || versionDetailsErrorOrLoading.loading;
  const error = scopesErrorOrLoading.error || installConfigLoadingOrErr.error || versionDetailsErrorOrLoading.error;
  const blockInstall = loading || !!error;
  return {
    blockInstall,
    updateErrAndLoadingState,
    error: !!error
  };
};